<template>
  <div class="header">
    <div class="headercenter">
      <img src="@/assets/login.png" class="logmng" />
      <div>{{biaoTi}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      biaoTi: localStorage.getItem('biaoti'),
    }
  }
}
</script>
<style scoped>
.header {
  height: 60px;
  background-color: rgba(50, 65, 96, 1);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
}
.headercenter {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.logmng {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}
</style>



